import React, { useState, useEffect } from "react"
import axios from "axios"
import Header from "../components/Header"
import { Carousel } from "flowbite-react"

import NewsEvent from "../components/HomePage/News"
import ProkerAndTeam from "../components/HomePage/Proker"
import ExtraSection from "../components/HomePage/Extra"
import GallerySection from "../components/HomePage/gallery"
import Milestone from "../components/HomePage/Milestone"
import AboutSection from "../components/HomePage/About"
import Footer from "../components/Footer"

export default function HomePage() {
    const [news, setNews] = useState([])
    const [proker, setProker] = useState([])
    const [extra, setExtra] = useState([])
    const [gallery, setGallery] = useState([])
    const [slider, setSlider] = useState([])
    const [about, setAbout] = useState([])

    useEffect(() => {
        const hash = window.location.hash;
        if (hash && document.querySelector(hash)) document.querySelector(hash).scrollIntoView({ behavior: 'smooth' });
        const fetchSlider = async () => {
            const Slider = await window.apiClient.get('/data/slider')
            setSlider(Slider.data)
        }
        const fetchNews = async () => {
            const News = await window.apiClient.get('/data/article/4/1')
            setNews(News.data);
        }
        const fetchProker = async () => {
            const Proker = await window.apiClient.get('/data/proker/3/1')
            setProker(Proker.data)
        }
        const fetchExtra = async () => {
            const Extra = await window.apiClient.get('/data/extra')
            setExtra(Extra.data)
        }
        const fetchGallery = async () => {
            const Gallery = await window.apiClient.get('/data/gallery/3/1')
            setGallery(Gallery.data);
        }
        const fetchAbout = async () => {
            const About = await window.apiClient.get('/data/about')
            setAbout(About.data)
        }
        fetchSlider()
        fetchNews()
        fetchProker()
        fetchExtra()
        fetchGallery()
        fetchAbout()
    }, [])

    return <>
        <Header />
        <div className="h-56 sm:h-64 xl:h-80 2xl:h-96">
            <Carousel leftControl=" " rightControl=" ">
                {slider.map((slide, index) => (
                    <img
                        key={index}
                        src={`https://admin.sman2amlapura.sch.id/images/image_album/${slide['url_image']}`}
                        alt={slide['caption_image']}
                    />
                ))}
            </Carousel>
        </div>
        <NewsEvent artikel={news} />
        <ProkerAndTeam listKasi={proker} />
        <ExtraSection listExtra={extra} />
        <GallerySection album={gallery} />
        <Milestone data={
            {
                "people": proker.pagination?.total_items || 0,
                "extra": extra.length,
                "artikel": news.pagination?.total_items || 0,
                "album": gallery.pagination?.total_items || 0
            }
        } />
        <AboutSection
            visimisi={about.visimisi}
            gambarVisi={about.gambarVisi}
            gambarKesan={about.gambarKesan}
            kesankesan={about.kesankesan}
        />

        {/* Gunakan ini jika AboutSection dari Database terlihat jelek */}
        {/* <AboutSection
            visimisi={"<blockquote class='space-y-4 leading-relaxed text-gray-300'><p class='text-base md:text-lg'><strong class='font-semibold text-white'>NEVOZION</strong>, sebuah kisah yang tercipta dari Kepengurusan OSIS &amp; MPK SMA Negeri 2 Amlapura Periode 2024.</p><p class='text-base md:text-lg'>NEVOZION diambil dari empat unsur kata, yaitu <strong class='font-semibold text-white'>NAGA</strong> yang melambangkankeberanian, <strong class='font-semibold text-white'>EVOLUSI</strong> yaitu perubahan, <strong class='font-semibold text-white'>SPAZIO</strong> yang berarti angkasa, dan <strong class='font-semibold text-white'>ION</strong> yakni air.</p><p class='text-base md:text-lg'>Secara utuh, NEVOZION menyimpan arti dan harapan agar Pengurus OSIS &amp; MPK SMA Negeri 2 Amlapura Periode 2024memiliki pemikiran seluas angkasa untuk selalu menghadirkan inovasi berlandaskan keberanian agar dapat bermanfaatdan bersinar layaknya matahari, bulan, dan bintang, serta berpendirian tangguh dalam mengemban tugas.</p></blockquote ><h5 class='mt-6 text-xl font-bold text-center text-white'>Kami Pengurus OSIS &amp; MPK SMA Negeri 2 Amlapura Periode 2024, <span class='text-yellow-400'>NEVOZION</span>.</h5>"}
            gambarVisi={"iconArtikel_GEskOn7Y1720533132.png"}
            gambarKesan={"iconArtikel_X46wof1N1584950151.png"}
            kesankesan={"<p><br></p><p>&nbsp;&nbsp;<span style='font-size: 18px;'>Hey You can Contact </span><span style='font-size: 18px;'></span><span style='font-size: 18px;'>us in:</span></p><p class='flex'>&nbsp;<img src='https://admin.sman2amlapura.sch.id/images/artikel/photo_GO251VoE1584950885.png' style='width: 40.4375px; height: 40.4375px;'>&nbsp;&nbsp;<span style='font-size: 18px;'>@osismpk_smandapura</span></p>"}
        /> */}
        <Footer />
    </>;
}
